/**
 * @fileoverview Module for `src/lib/functions/isInvalidLoginError.js`.
 */

/**
 * Reports whether a request failed because its token has no matching login record.
 *
 * @param {*} err - Error thrown by an axios request.
 * @returns {boolean} True for a 409 response flagged `invalidLogin`.
 */
function isInvalidLoginError(err) {
  return err?.response?.status === 409 && err.response.data?.invalidLogin === true;
}

export default isInvalidLoginError;
